import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class UploadWareBaseComponent extends BaseComponent {
  public text: string = "UploadWare";

  constructor(public userService: UserService) {
    super(userService);
  }
}
